<template>
	<div class="qualification-home">
		<div class="service-container">
			<div class="service-cards">
				<div class="card-item card-item_left">
					<img src="@/assets/qualificationService/service_b1.png" alt="资质标准一目了然，洞悉变化" />
				</div>
				<div class="card-item card-item_right">
					<img src="@/assets/qualificationService/service_b2.png" alt="资质诊断，1分钟为您快速诊断，筑梦资质维护" />
				</div>
			</div>
		</div>

		<!-- 资质办理流程图 -->
		<div class="process-container">
			<div class="process-wrapper">
				<img
					class="process-image"
					src="@/assets/qualificationService/process-section.png"
					alt="资质宝助力办理"
					usemap="#ProcessImageMap" />

				<!-- 图像热点区域创建超链接 -->
				<map id="ProcessImageMap" name="ProcessImageMap">
					<area
						shape="rect"
						coords="363, 190, 602, 257"
						alt="资质新办、资质升级、资质更新/延续"
						@click.prevent="handleImageHotAreaClick('/qualification/new')" />
					<area
						shape="rect"
						coords="655, 190, 934, 257"
						alt="资质诊断报告、人员推送、人工客服辅助"
						@click.prevent="handleImageHotAreaClick('/qualification/new')" />
					<area
						shape="rect"
						coords="1080, 190, 1272, 257"
						alt="证书委托维护"
						@click.prevent="handleImageHotAreaClick('/qualification/maintenance')" />
				</map>
			</div>
		</div>

		<!-- 紧要政策推送--start -->
		<!-- <div class="policy-container">
			<div class="policy-content">
				<h3 class="moudleDefaultTitle">紧要政策推送</h3>

				<div class="policy-columns">
					<!== 左侧建筑资质栏目 ==>
					<div class="policy-column">
						<div class="section-title">
							<div class="section-title_left building-icon">
								<h3>建筑资质</h3>
							</div>
							<router-link to="/policy" class="section-title_more">
								更多
								<i class="el-icon-arrow-right"></i>
							</router-link>
						</div>

						<div v-if="buildingPolicyList.length > 0" class="list-pic-box">
							<!== 第一条带缩略图的数据 ==>
							<div
								v-if="buildingPolicyList[0]"
								class="list-thumbnail"
								@click="handleOpenSourceUrl(buildingPolicyList[0].policySourceUrl)"
							>
								<div class="list-thumbnail_img">
									<img src="@/assets/qualificationService/list-pic_01.jpg" alt="建筑智能化资质一级资质标准是什么?" />
								</div>
								<div class="list-thumbnail_content">
									<h4 class="list-thumbnail_title">{{ buildingPolicyList[0].policyTitle }}</h4>
									<p class="list-thumbnail_desc">{{ buildingPolicyList[0].policyContent }}</p>
									<div class="list-thumbnail_date">{{ buildingPolicyList[0].createTime | formatDate }}</div>
								</div>
							</div>

							<!== 其他列表项 ==>
							<div class="list-text">
								<div
									v-for="(item, index) in buildingPolicyList.slice(1, 6)"
									:key="index"
									class="list-text_item"
									@click="handleOpenSourceUrl(item.policySourceUrl)"
								>
									<div class="list-text_title">{{ item.policyTitle }}</div>
									<div class="list-text_date">{{ item.createTime | formatDate }}</div>
								</div>
							</div>
						</div>
						<!== 数据为空 ==>
						<empty-content v-else></empty-content>
					</div>

					<!== 右侧资质办理栏目 ==>
					<div class="policy-column">
						<div class="section-title">
							<div class="section-title_left qualification-icon">
								<h3>住建类政策文件</h3>
							</div>
							<router-link to="/policy" class="section-title_more">
								更多
								<i class="el-icon-arrow-right"></i>
							</router-link>
						</div>

						<div v-if="urbanPolicyList.length > 0" class="list-pic-box">
							<!== 第一条带缩略图的数据 ==>
							<div
								v-if="urbanPolicyList[0]"
								class="list-thumbnail"
								@click="handleOpenSourceUrl(urbanPolicyList[0].policySourceUrl)"
							>
								<div class="list-thumbnail_img">
									<img src="@/assets/qualificationService/list-pic_02.jpg" alt="建筑智能化资质一级资质标准是什么?" />
								</div>
								<div class="list-thumbnail_content">
									<h4 class="list-thumbnail_title">{{ urbanPolicyList[0].policyTitle }}</h4>
									<p class="list-thumbnail_desc">{{ urbanPolicyList[0].policyContent }}</p>
									<div class="list-thumbnail_date">{{ urbanPolicyList[0].createTime | formatDate }}</div>
								</div>
							</div>

							<!== 其他列表项 ==>
							<div class="list-text">
								<div
									v-for="(item, index) in urbanPolicyList.slice(1, 6)"
									:key="index"
									class="list-text_item"
									@click="handleOpenSourceUrl(item.policySourceUrl)"
								>
									<div class="list-text_title">{{ item.policyTitle }}</div>
									<div class="list-text_date">{{ item.createTime | formatDate }}</div>
								</div>
							</div>
						</div>

						<!== 数据为空 ==>
						<empty-content v-else></empty-content>
					</div>
				</div>
			</div>
		</div> -->
		<!-- 紧要政策推送--end -->

		<!-- 资质维护板块--start -->
		<div class="maintenance-container">
			<div class="maintenance-content">
				<h3 class="moudleDefaultTitle">资质维护</h3>

				<!-- banner图 -->
				<div class="maintenance-banner">
					<div class="banner-image">
						<img src="@/assets/qualificationService/maintenance-banner.png" alt="资质维护" />
					</div>
				</div>

				<div class="tab-container">
					<!-- tab切换区域--start -->
					<div class="cjt-tabs">
						<div class="cjt-tabs__header">
							<div class="cjt-tabs__nav-wrap">
								<div
									v-for="(tab, index) in maintenanceTabs"
									:key="index"
									class="cjt-tabs__item"
									:class="{ active: activeTabIndex === index }"
									@click="changeMaintenanceTab(index)">
									<span class="cjt-tabs__item-text">{{ tab.name }}</span>
									<!-- <span class="cjt-tabs__item-badge">{{ tab.count }}</span> -->
								</div>

								<!-- <div class="cjt-tabs-more">
									<router-link to="#">
										更多
										<i class="el-icon-arrow-right"></i>
									</router-link>
								</div> -->
							</div>
						</div>
						<div class="cjt-tabs__container">
							<!-- 内容区域 -->
							<transition name="fade-transform" mode="out-in">
								<div :key="activeTabIndex" class="cjt-tabs__content">
									<!-- 临期提醒内容 -->
									<div v-if="activeTabIndex === 0" class="maintenance-list">
										<!-- 列表项 -->
										<div
											v-for="(item, index) in nearExpiryNotificationList"
											:key="index"
											class="notification-item"
											:class="{
												urgent: item.type === '1',
												warning: item.type === '2',
												notice: item.type === '3',
												normal: item.type === '4'
											}">
											<div class="certificate-info">
												<div class="certificate-name">
													<div>
														<svg-icon icon-class="enterprise" class="certificate-icon"></svg-icon>
														{{ item.name }}
													</div>
												</div>
												<div class="certificate-detail">
													<div class="detail-item">
														<label>资质类别：</label>
														<span class="detail-content">
															{{ item.qualificationType }}
														</span>
													</div>
													<div class="detail-item">
														<label>注册时间：</label>
														<span class="detail-content">{{ item.registerTime }}</span>
													</div>
													<div class="detail-item">
														<label>有效时间：</label>
														<span class="detail-content">{{ item.validTime }}</span>
													</div>
												</div>
											</div>
											<div class="certificate-status">
												<div class="remainder">
													剩余时间
													<span class="remainder-num">{{ item.remainDays }}</span>
													<span class="remainder-day">天</span>
												</div>
												<div class="status-btn">
													{{ getStatusText(item.type) }}
												</div>
											</div>
										</div>
									</div>

									<!-- 其他Tab内容 -->
									<div v-if="activeTabIndex === 1" class="maintenance-list">
										<div v-for="(item, index) in logoutNotificationList" :key="index" class="notification-item">
											<div class="certificate-info no-fiexed">
												<div class="certificate-name">
													<div>
														<svg-icon icon-class="enterprise" class="certificate-icon"></svg-icon>
														{{ item.name }}
													</div>
													<div class="certificate-notice">可能存在不满足当前资质条件风险</div>
												</div>

												<div class="certificate-detail">
													<div class="detail-item">
														<label>资质类别：</label>
														<span class="detail-content">
															{{ item.qualificationType }}
														</span>
													</div>
													<div class="detail-item">
														<label>预警时间：</label>
														<span class="detail-content">{{ item.warningTime }}</span>
													</div>
												</div>
											</div>
										</div>

										<!-- <div class="empty-content">
											<i class="el-icon-document"></i>
											<p>暂无数据</p>
										</div> -->
									</div>

									<div v-if="activeTabIndex === 2" class="maintenance-list">
										<div v-for="(item, index) in registerNotificationList" :key="index" class="notification-item">
											<div class="certificate-info no-fiexed">
												<div class="certificate-name">
													<div>
														<svg-icon icon-class="enterprise" class="certificate-icon"></svg-icon>
														{{ item.name }}
													</div>
													<div class="certificate-notice">可能存在升级或更新延续条件</div>
												</div>

												<div class="certificate-detail">
													<div class="detail-item">
														<label>资质类别：</label>
														<span class="detail-content">
															{{ item.qualificationType }}
														</span>
													</div>
													<div class="detail-item">
														<label>预警时间：</label>
														<span class="detail-content">{{ item.warningTime }}</span>
													</div>
												</div>
											</div>
										</div>
										<!-- <div class="empty-content">
											<i class="el-icon-document"></i>
											<p>暂无数据</p>
										</div> -->
									</div>

									<div v-if="activeTabIndex === 3" class="maintenance-list">
										<div v-for="(item, index) in riskWarningNotificationList" :key="index" class="notification-item">
											<div class="certificate-info no-fiexed">
												<div class="certificate-name">
													<div>
														<svg-icon icon-class="enterprise" class="certificate-icon"></svg-icon>
														{{ item.name }}
													</div>
													<div class="certificate-notice">企业存在一条不良记录，可能影响资质办理、资质更新延续、资质升级</div>
												</div>

												<div class="certificate-detail">
													<div class="detail-item">
														<label>资质类别：</label>
														<span class="detail-content">
															{{ item.qualificationType }}
														</span>
													</div>
													<div class="detail-item">
														<label>预警时间：</label>
														<span class="detail-content">{{ item.warningTime }}</span>
													</div>
												</div>
											</div>
										</div>
										<!-- <div class="empty-content">
											<i class="el-icon-warning-outline"></i>
											<p>暂无风险提醒</p>
										</div> -->
									</div>
								</div>
							</transition>
						</div>
					</div>
					<!-- tab切换区域--end -->

					<!-- 底部按钮--start -->
					<div class="maintenance-footer">
						<button class="cjt-button cjt-button--primary" type="button" @click="$router.push('/qualification/maintenance')">
							<span>我要去维护</span>
							<!-- 会员功能取消屏蔽--start -->
							<!-- <span class="tag-member tag-member--vip">VIP</span> -->
							<!-- 会员功能取消屏蔽--end -->
						</button>
					</div>
					<!-- 底部按钮--end -->
				</div>
			</div>
		</div>
		<!-- 资质维护板块--end -->

		<!-- 资质办理流程--start -->
		<div class="process-container">
			<div class="process-content">
				<h3 class="moudleDefaultTitle">资质新办、升级、更新延续</h3>

				<div class="process-main">
					<div class="process-steps">
						<div
							v-for="(item, index) in processList"
							:key="index"
							class="step-item"
							:class="{ active: currentStep === index }"
							@mouseenter="handleStepHover(index)">
							<span class="step-num">{{ String(index + 1).padStart(2, '0') }}</span>
							<div>
								<p class="step-title">{{ item.title }}</p>
								<p class="step-desc">{{ item.desc }}</p>
							</div>
						</div>
					</div>
					<div class="process-swiper">
						<div class="swiper-wrapper">
							<div
								v-for="(item, index) in processList"
								:key="index"
								class="swiper-slide"
								:class="{ active: currentStep === index }">
								<img :src="item.imageUrl" :alt="item.title" />
							</div>
						</div>
					</div>

					<button class="cjt-button cjt-button--primary" type="button" @click="$router.push('/qualification/new')">
						<span>我要办理</span>
						<!-- 会员功能取消屏蔽--start -->
						<!-- <span class="tag-member tag-member--vip">VIP</span> -->
						<!-- 会员功能取消屏蔽--end -->
					</button>
				</div>
			</div>
		</div>
		<!-- 资质办理流程--end -->

		<!-- 广告位--start -->
		<!-- <div class="poster-container">
			<img
				src="@/assets/poster/poster-vip_01.jpg"
				alt="尊享会员，开启无忧通道，畅享高速精准诊断，您的解决方案触手可及"
				@click="handleLocationMemberBenefits"
			/>
		</div> -->
		<!-- 广告位--end -->

		<!-- 出具诊断报告--start -->
		<div class="report-container">
			<div class="report-content">
				<h3 class="moudleDefaultTitle">出具诊断报告</h3>
				<el-carousel :interval="3000" type="card" height="780px" :autoplay="false" arrow="always" class="carousel-wrapper">
					<el-carousel-item v-for="(item, index) in reportList" :key="index">
						<img :src="item.imageUrl" :alt="item.title" />
					</el-carousel-item>
				</el-carousel>
				<!-- <div class="report-swiper-wrapper">
					<swiper ref="reportSwiper" :options="reportSwiperOptions" class="report-swiper">
						<swiper-slide v-for="(item, index) in reportList" :key="index" class="report-slide">
							<div class="report-slide-content">
								<img :src="item.imageUrl" :alt="item.title" />
							</div>
						</swiper-slide>
						<div slot="button-prev" class="swiper-button-prev"></div>
						<div slot="button-next" class="swiper-button-next"></div>
					</swiper>

					<div class="report-action">
						<button class="cjt-button cjt-button--primary" type="button">
							<span>立即前往</span>
							<span class="tag-member tag-member--svip">SVIP</span>
						</button>
					</div>
				</div> -->
			</div>
			<!-- 底部按钮--start -->
			<div class="report-action">
				<button class="cjt-button cjt-button--primary" type="button" @click="$router.push('/qualification/new')">
					<span>立即前往</span>
					<!-- 会员功能取消屏蔽--start -->
					<!-- <span class="tag-member tag-member--svip">SVIP</span> -->
					<!-- 会员功能取消屏蔽--end -->
				</button>
			</div>
			<!-- 底部按钮--end -->
		</div>
		<!-- 出具诊断报告--end -->

		<div class="service-module-container">
			<div class="service-module-content">
				<h3 class="moudleDefaultTitle">还没找到合适的资质服务</h3>
				<p class="service-sub-title">试试以下精彩</p>
				<div class="service-module-cards">
					<div class="service-card">
						<div class="service-card-content">
							<h4 class="service-card-title">提交您的需求</h4>
							<p class="service-card-desc">专属客服一对一，专业寻找合适的资质服务</p>
							<button class="service-card-btn" @click="openQQService">立即咨询</button>
						</div>
					</div>
					<div class="service-card">
						<div class="service-card-content">
							<h4 class="service-card-title">专业顾问</h4>
							<p class="service-card-desc">为您解决烦忧-24小时在线 专业服务</p>
							<button class="service-card-btn" @click="openQQService">立即咨询</button>
						</div>
					</div>
					<div class="service-card">
						<div class="service-card-content">
							<h4 class="service-card-title">投诉建议</h4>
							<p class="service-card-desc">提供专业服务-尽心听取意见</p>
							<button class="service-card-btn" @click="openQQService">立即咨询</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// 资质宝首页
	// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
	import 'swiper/css/swiper.css'
	import { getPolicyList } from '@/api/policy/index'
	import QQService from '@/mixins/QQService'

	export default {
		name: 'QualificationIndex',
		components: {
			// Swiper,
			// SwiperSlide
		},
		mixins: [QQService],
		props: {},
		data() {
			return {
				// 建筑资质类政策数据
				buildingPolicyList: [],
				// 住建类政策文件类政策数据
				urbanPolicyList: [],
				// 资质维护Tab数据
				activeTabIndex: 0,
				maintenanceTabs: [
					{ name: '临期提醒', count: 4 },
					{ name: '注销提醒', count: 4 },
					{ name: '注册提醒', count: 4 },
					{ name: '风险提醒', count: 4 }
				],

				// 临期提醒
				nearExpiryNotificationList: [
					{
						type: '1', // 提醒标识：（1：urgent；2：warning；3：notice；4：normal）
						name: '建筑业企业资质证书',
						qualificationType: '********',
						registerTime: '20**-**-**',
						validTime: '20**-**-**',
						remainDays: 30
					},
					{
						type: '2',
						name: '建设工程设计企业资质证书',
						qualificationType: '********',
						registerTime: '20**-**-**',
						validTime: '20**-**-**',
						remainDays: 60
					},
					{
						type: '3',
						name: '建设工程勘察企业资质证书',
						qualificationType: '********',
						registerTime: '20**-**-**',
						validTime: '20**-**-**',
						remainDays: 90
					},
					{
						type: '4',
						name: '建设工程质量检测机构资质证书',
						qualificationType: '********',
						registerTime: '20**-**-**',
						validTime: '20**-**-**',
						remainDays: 100
					}
				],

				// 注销提醒
				logoutNotificationList: [
					{
						name: '建筑业企业资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程设计企业资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程勘察企业资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程质量检测机构资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					}
				],

				// 注册提醒
				registerNotificationList: [
					{
						name: '建筑业企业资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程设计企业资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程勘察企业资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程质量检测机构资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					}
				],

				// 风险提醒
				riskWarningNotificationList: [
					{
						name: '建筑业企业资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程设计企业资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程勘察企业资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					},
					{
						name: '建设工程质量检测机构资质证书',
						qualificationType: '********',
						warningTime: '20**-**-**'
					}
				],

				currentStep: 0,
				processTimer: null,
				processList: [
					{
						title: '资质咨询',
						desc: '专业咨询服务',
						imageUrl: require('@/assets/index/process/001.png')
					},
					{
						title: '立即诊断',
						desc: '精准资质诊断',
						imageUrl: require('@/assets/index/process/002.png')
					},
					{
						title: '诊断结果',
						desc: '输出诊断报告',
						imageUrl: require('@/assets/index/process/003.png')
					},
					{
						title: '一键定制',
						desc: '定制解决方案',
						imageUrl: require('@/assets/index/process/004.png')
					},
					{
						title: '智能协助',
						desc: '专业服务协助',
						imageUrl: require('@/assets/index/process/005.png')
					}
				],

				// 添加诊断报告数据
				reportList: [
					{
						title: '诊断报告1',
						imageUrl: require('@/assets/report/report-1.jpg')
					},
					{
						title: '诊断报告2',
						imageUrl: require('@/assets/report/report-2.jpg')
					},
					{
						title: '诊断报告3',
						imageUrl: require('@/assets/report/report-3.jpg')
					}
					// {
					// 	title: '诊断报告4',
					// 	imageUrl: require('@/assets/report/report-1.jpg')
					// },
					// {
					// 	title: '诊断报告5',
					// 	imageUrl: require('@/assets/report/report-2.jpg')
					// }
				],
				// 诊断报告轮播配置
				reportSwiperOptions: {
					// speed: 2000,
					watchSlidesProgress: true,
					slidesPerView: 'auto',
					centeredSlides: true,
					loop: true,
					loopedSlides: 5,
					// loopAdditionalSlides: 2,
					autoplay: true,
					on: {
						// progress: function(progress) {
						// 	// console.log('this:', this)
						// 	for (let i = 0; i < this.slides.length; i++) {
						// 		let slide = this.slides.eq(i)
						// 		let slideProgress = this.slides[i].progress
						// 		let modify = 1
						// 		if (Math.abs(slideProgress) > 1) {
						// 			modify = (Math.abs(slideProgress) - 1) * 0.3 + 1
						// 		}
						// 		let translate = slideProgress * modify * 260 + 'px'
						// 		let scale = 1 - Math.abs(slideProgress) / 5
						// 		let zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
						// 		slide.transform('translateX(' + translate + ') scale(' + scale + ')')
						// 		slide.css('zIndex', zIndex)
						// 		slide.css('opacity', 1)
						// 		if (Math.abs(slideProgress) > 3) {
						// 			slide.css('opacity', 0)
						// 		}
						// 	}
						// },
						// setTransition: function(transition) {
						// 	for (let i = 0; i < this.slides.length; i++) {
						// 		let slide = this.slides.eq(i)
						// 		slide.transition(transition)
						// 	}
						// }
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				}
			}
		},
		computed: {},
		watch: {},
		created() {
			// this.handleQueryPolicyByType('1')
			// this.handleQueryPolicyByType('99')
		},
		mounted() {
			this.$nextTick(() => {
				// this.startProcessTimer()
				// 确保Swiper正确初始化
				// setTimeout(() => {
				// 	if (this.$refs.reportSwiper && this.$refs.reportSwiper.$swiper) {
				// 		this.$refs.reportSwiper.$swiper.update()
				// 	}
				// }, 300)
			})
		},
		beforeDestroy() {
			this.clearProcessTimer()
		},
		methods: {
			handleQueryPolicyByType(queryType) {
				const params = {
					page: 1,
					size: 6,
					policyType: queryType
				}

				getPolicyList(params)
					.then(response => {
						const { data } = response
						if (data && data.records) {
							if (queryType === '1') {
								// 查询建筑业政策快讯
								this.buildingPolicyList = data.records || []
							} else if (queryType === '99') {
								// 查询住建政策文件类政策快讯
								this.urbanPolicyList = data.records || []
							}
						} else {
							if (queryType === '1') {
								this.buildingPolicyList = []
							} else if (queryType === '99') {
								this.urbanPolicyList = []
							}
						}
					})
					.catch(() => {
						if (queryType === '1') {
							this.buildingPolicyList = []
						} else if (queryType === '99') {
							this.urbanPolicyList = []
						}
					})
			},

			// 新标签页打开政策快讯外链
			handleOpenSourceUrl(policySourceUrl) {
				window.open(policySourceUrl, '_blank')
			},

			// 点击图像热点区域进行跳转
			handleImageHotAreaClick(path) {
				// todo: 暂未上线此功能，后期上线后打开--start
				this.$router.push(path)
				// todo: 暂未上线此功能，后期上线后打开--end
			},

			// 切换Tab
			changeMaintenanceTab(index) {
				this.activeTabIndex = index
			},

			// 根据类型获取状态文本
			getStatusText(type) {
				const statusMap = {
					1: '紧急提示',
					2: '紧急提示',
					3: '友情提示',
					4: '友情提示'
				}
				return statusMap[type] || '普通提示'
			},

			startProcessTimer() {
				this.clearProcessTimer()
				this.processTimer = setInterval(() => {
					this.currentStep = (this.currentStep + 1) % this.processList.length
				}, 3000)
			},
			clearProcessTimer() {
				if (this.processTimer) {
					clearInterval(this.processTimer)
					this.processTimer = null
				}
			},
			handleStepHover(index) {
				this.currentStep = index
				this.startProcessTimer() // 重置定时器
			},

			// 打开企点客服
			openQQService() {
				this.handleEvokeQQ()
			},

			// 跳转会员权益办理页面
			handleLocationMemberBenefits() {
				this.$router.push({
					path: '/member-benefits'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.qualification-home {
		position: relative;

		.banner-unopen {
			position: fixed;
			width: 100%;
			height: 150px;
			top: 50%;
			transform: translateY(-75px);
		}

		.service-container {
			padding: 20px 0;
			background-color: #f5f9fb;
		}

		.service-cards {
			width: $main-page-width;
			margin: 0 auto;
			display: flex;

			.card-item {
				flex: 1;
				background: #fff;
				border-radius: 8px;
				overflow: hidden;
				cursor: pointer;
				transition: all 0.3s;
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.17);

				& + .card-item {
					margin-left: 20px;
				}

				&:hover {
					transform: translateY(-5px);
					box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
				}

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
					vertical-align: middle;
				}

				&_left {
					flex: 0 0 927px;
					max-width: 927px;
				}

				&_right {
					flex: 0 0 453px;
					max-width: 453px;
				}
			}
		}

		// 流程图容器
		.process-container {
			background-color: #f5f9fb;
			padding: 20px 0;

			.process-image {
				display: block;
				margin: 0 auto;
			}

			area {
				cursor: pointer;
			}
		}

		// 紧要政策推送
		.policy-container {
			background-color: #ffffff;
			padding: 20px 0;

			.policy-content {
				width: $main-page-width;
				margin: 0 auto;

				.policy-columns {
					display: flex;
					justify-content: space-between;
					gap: 20px;

					.policy-column {
						background: #fff;
						border-radius: 8px;
						padding: 20px;
						box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
						width: calc(50% - 10px); // 明确设置宽度
						max-width: calc(50% - 10px); // 限制最大宽度

						.section-title {
							.section-title_left {
								&.building-icon::before {
									background-image: url('~@/assets/icons.png');
									background-position: -64px -32px;
								}

								&.qualification-icon::before {
									background-image: url('~@/assets/icons.png');
									background-position: -192px 0px;
								}
							}
						}
					}
				}
			}
		}

		// 资质维护
		.maintenance-container {
			background-color: #f5f9fb;
			padding: 20px 0;

			.maintenance-content {
				width: $main-page-width;
				margin: 0 auto;

				.maintenance-banner {
					border-radius: 8px;
					margin-bottom: 20px;

					.banner-image {
						width: $main-page-width;
						overflow: hidden;

						img {
							width: 100%;
							transition: transform 0.3s;
						}

						&:hover {
							img {
								transform: scale(1.05);
							}
						}
					}
				}

				.tab-container {
					padding: 20px;
					background-color: #ffffff;
					box-shadow: 2px 7px 21px 0px rgba(57, 127, 212, 0.17);
					border-radius: 6px;
				}

				.maintenance-footer {
					display: flex;
					justify-content: center;
					margin-top: 26px;
				}
			}
		}

		// 改写提醒列表部分样式
		.maintenance-list {
			.notification-item {
				.certificate-info.no-fiexed {
					flex: 1;
				}
			}
		}

		// 资质办理流程
		.process-container {
			background-color: #f5f9fb;
			padding: 20px 0;
			.process-content {
				width: $main-page-width;
				margin: 0 auto;
				.process-main {
					height: 761px;
					background-color: #d5eafd;
					border-radius: 6px;
					padding: 20px;
					display: flex;
					flex-direction: column;
					align-items: center;
					gap: 30px;

					.process-steps {
						display: flex;
						justify-content: space-between;
						width: 100%;

						.step-item {
							display: flex;
							align-items: center;
							gap: 10px;
							padding: 15px 6px;
							cursor: pointer;
							transition: all 0.3s;
							border-radius: 4px;
							position: relative;
							&::after {
								content: '';
								display: block;
								position: absolute;
								background-image: url('~@/assets/index/process/process-arr.png');
								width: 29px;
								height: 10px;
								right: -80px;
								position: absolute;
							}
							&:last-child::after {
								content: '';
								display: none;
							}

							&:hover,
							&.active {
								.step-num {
									background-image: linear-gradient(146deg, #205eda 0%, #3b74e6 100%);
									opacity: 1;
								}

								.step-title {
									color: #1374eb;
								}
							}

							.step-num {
								width: 40px;
								height: 40px;
								border-radius: 50%;
								line-height: 40px;
								text-align: center;
								background-image: linear-gradient(146deg, #205eda 0%, #3b74e6 100%);
								box-shadow: 1px 6px 7px 0px rgba(45, 156, 232, 0.17);
								opacity: 0.5;
								color: #fff;
								font-size: 20px;
							}

							.step-title {
								font-size: 16px;
								color: #333;
								font-weight: 500;
								transition: all 0.3s;
							}

							.step-desc {
								font-size: 14px;
								color: #666;
							}
						}
					}

					.process-swiper {
						position: relative;
						height: 539px;
						width: 100%;
						overflow: hidden;
						border-radius: 8px;

						.swiper-wrapper {
							height: 100%;
							transition: all 0.5s ease;
						}

						.swiper-slide {
							position: absolute;
							width: 100%;
							height: 100%;
							opacity: 0;
							transition: all 0.5s ease;

							&.active {
								opacity: 1;
							}

							img {
								width: 100%;
								height: 100%;
								// object-fit: cover;
							}
						}
					}
				}
			}
		}

		// 诊断报告
		.report-container {
			::v-deep(.el-carousel__container) {
				text-align: center !important;
				.el-carousel__arrow {
					background-color: #fff !important;
					color: #1374eb !important;
					font-size: 20px !important;
					&:hover {
						background-color: #1374eb !important;
						color: #fff !important;
					}
				}

				.el-carousel__arrow--left {
					left: 0;
				}

				.el-carousel__arrow--right {
					right: 0;
				}
			}
			.carousel-wrapper {
				text-align: center;
				::v-deep(.el-carousel__mask) {
					background-color: transparent !important;
				}

				::v-deep {
					.el-carousel__item {
						img {
							border: solid 1px #ededed;
							box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
						}
					}
				}
			}
			::v-deep(.el-carousel__indicators) {
				display: none;
			}

			background-image: url('~@/assets/index/bottom-bg.png');
			background-repeat: no-repeat;
			background-position: center;
			padding: 20px 0;

			.report-content {
				width: $main-page-width;
				margin: 0 auto;
				position: relative;
				z-index: 1;
			}

			.report-swiper-wrapper {
				padding: 30px 0;
				// overflow: hidden;
				position: relative;
			}

			.report-swiper {
				padding: 20px 0;
				// overflow: visible;
			}

			.report-slide {
				width: 520px !important;
				height: 740px;
				background: #fff;
				box-shadow: 0 8px 30px #ddd;
				// transition: all 0.3s ease;
				// opacity: 0.7;
				// transform: scale(0.85);

				// &-active {
				// 	// opacity: 1;
				// 	// transform: scale(1);
				// 	// z-index: 2;

				// 	.report-slide-content {
				// 		border-color: #1374eb;
				// 		box-shadow: 0 10px 25px rgba(19, 116, 235, 0.2);
				// 	}
				// }

				.report-slide-content {
					width: 100%;
					height: 100%;
					box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
					border-radius: 8px;
					overflow: hidden;
					background: #fff;
					border: 2px solid transparent;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
						display: block;
					}
				}
			}

			.swiper-button-prev,
			.swiper-button-next {
				width: 40px;
				height: 40px;
				background: #fff;
				border-radius: 50%;
				box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
				color: #1374eb;

				&::after {
					font-size: 16px;
				}

				&:hover {
					background: #1374eb;
					color: #fff;
				}
			}

			.report-action {
				text-align: center;
				margin-top: 30px;
			}
		}

		// 更多资质服务
		.service-module-container {
			background-color: #ffffff;
			background-image: url('~@/assets/qualificationService/wave-bg.png');
			background-repeat: no-repeat;
			background-position: bottom;
			padding: 20px 0;
			.service-module-content {
				width: $main-page-width;
				margin: 0 auto;

				.service-sub-title {
					font-size: 22px;
					color: #333333;
					text-align: center;
				}

				.service-module-cards {
					display: flex;
					justify-content: space-between;
					margin-top: 30px;

					.service-card {
						position: relative;
						width: 453px;
						height: 262px;
						background-repeat: no-repeat;
						background-size: 100% 100%;
						border-radius: 6px;
						border: solid 1px #b2d8ff;
						box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
						display: flex;
						overflow: hidden;
						transition: all 0.3s;

						&:hover {
							transform: translateY(-5px);
							box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
						}

						.service-card-content {
							flex: 1;
							padding: 40px 140px 40px 40px;
							display: flex;
							flex-direction: column;

							.service-card-title {
								font-size: 24px;
								font-weight: 500;
								color: #246fca;
								margin-bottom: 20px;
							}

							.service-card-desc {
								font-size: 18px;
								color: #333333;
								line-height: 1.5;
								margin-bottom: 20px;
							}

							.service-card-btn {
								width: 120px;
								height: 36px;
								background-image: linear-gradient(90deg, #237ff5 0%, #51bdf7 100%);
								border-radius: 20px;
								color: #fff;
								border: none;
								border-radius: 4px;
								font-size: 18px;
								cursor: pointer;
								transition: all 0.3s;
								position: absolute;
								left: 40px;
								bottom: 40px;

								&:hover {
									background: #0d5ecc;
								}
							}
						}
					}

					.service-card:nth-child(1) {
						background-image: url('~@/assets/qualificationService/service-module-card_01.png');
					}

					.service-card:nth-child(2) {
						background-image: url('~@/assets/qualificationService/service-module-card_02.png');
					}

					.service-card:nth-child(3) {
						background-image: url('~@/assets/qualificationService/service-module-card_03.png');
					}
				}
			}
		}
	}
</style>
